<template>
    <div id="app">
        <router-view :key="$route.fullPath"/>
    </div>
</template>

<script>
    export default {
        name: 'App',
    }

</script>

<style lang="scss">
    @import "@/assets/scss/common.scss";
</style>